import React, { useState, useEffect } from 'react';
import ellipsis from "../../assets/images/ellipsis.png";
import deletebtn from "../../assets/images/delete.png";
import "./comments.css";
import { decorator } from "../common/decorator";
import { postData } from "../common/utils";
import OutsideClickHandler from 'react-outside-click-handler';
import { useAlert } from "react-alert";
import { EditorState, convertFromRaw } from "draft-js";

const DeleteComment = (props) => {
  const [comDropDown, setComDropDown] = useState(false);
  const [disable, setDisable] = React.useState(false);
  const [comcanDelete, setcomCanDelete] = useState(false);
  const alert = useAlert();

  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    com_delete_user_check();
    // if (props.data.postJSON !== "" && props.data.postJSON !== null) {
    //   setEditorState(
    //     EditorState.createWithContent(
    //       convertFromRaw(JSON.parse(props.data.postJSON)),
    //       decorator
    //     )
    //   );
    //   //setEditorState(EditorState.push(editorState,convertFromRaw(JSON.parse(props.data.postJSON))));
    // }

  }, []);



  const com_delete_user_check = () => {
    var data = {
      user_id: props.data.userID,
      postcommentid: props.data.postCommentID,
    };
    postData(
      process.env.REACT_APP_API_URL + "api/post/commentdeletecheck",
      data
    ).then((data) => {
      if (data.issuccessful == true) {
        //window.location.reload();
        //  var test = props.refresh;
        //  props.setRefresh(++test);
        //  alert.success(data.message);
        //refreshPage(data);

        //console.log(data,"noo");
        setcomCanDelete(true);

      } else {
        //   alert.error(data.message);
        setcomCanDelete(false);
      }
    })
      .catch((error) => {
        alert.error("Error", error);

      })

  }

  const deleteComment = () => {

    //console.log("API")
    //setDisable(true);
    //console.log("props check", props);
    var data = {
      user_id: props.data.userID,
      postcommentid: props.data.postCommentID,
    };
    //console.log("cmtdata", data);
    postData(
      process.env.REACT_APP_API_URL + "api/post/deletecomment",
      data
    )
      .then((data) => {
        if (data.issuccessful == true) {
          //window.location.reload();
          //  var test = props.refresh;
          //  props.setRefresh(++test);
          alert.success(data.message);
          refreshPage(data);
          //console.log("API Called")

        } else {
          alert.error(data.message);
        }
      })
      .catch((error) => {
        alert.error("Error", error);

      })

    // console.log(props.data);

  }

  function refreshPage() {
    setTimeout(() => {
      window.location.reload(false);

    }, 1000)

  }
  //console.log("u1", props.data.userID, "u2", props.data.UserID);
  return (
    <div className="pp-menu" style={{ position: "relative" }}>
      <img
        //style={{float: "right", marginTop:"-20px"}}
        className="pp-menu-img"
        src={ellipsis}
        alt=""
        onClick={() => { setComDropDown(true) }}
      />
      {comcanDelete &&
        <OutsideClickHandler onOutsideClick={() => { setComDropDown(false) }} >
          {
            comDropDown &&
            <div className="inner-menu-dropdown" style={{
              marginTop: "2px",
              position: "absolute",
              right: "-30px",
              border: "none",
              textAlign: "center",
              zIndex: "9999",
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "10px",
              marginRight: "5px",
              boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.15)"
            }}>
              <button
                className="dropdown-item-btn"
                onClick={deleteComment}
                disabled={disable}>
                <img className="btn-icon" src={deletebtn} alt="" />
                Delete
              </button>
            </div>
          }
        </OutsideClickHandler>
      }
    </div>
  )
}

export default DeleteComment;